import { render, staticRenderFns } from "./cidade-solidaria.vue?vue&type=template&id=f6e5dfa6&scoped=true&"
import script from "./cidade-solidaria.vue?vue&type=script&lang=js&"
export * from "./cidade-solidaria.vue?vue&type=script&lang=js&"
import style0 from "./cidade-solidaria.vue?vue&type=style&index=0&id=f6e5dfa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e5dfa6",
  null
  
)

export default component.exports